import { render, staticRenderFns } from "./ItemDiscountModal.vue?vue&type=template&id=676466f2"
import script from "./ItemDiscountModal.vue?vue&type=script&lang=ts"
export * from "./ItemDiscountModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports